var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['progress-bar', 'progress-bar-'+_vm.type, {active:_vm.animated, 'progress-bar-striped':_vm.striped}],style:({width: _vm.nowNum+'%'}),domProps:{"textContent":_vm._s(_vm.labelBool ? _vm.nowNum+'%' : null)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52249636","hasScoped":false,"buble":{"transforms":{}}}!./src/progressbar/template.html
// module id = 185
// module chunks = 0